module.exports = __webpack_public_path__ + "assets/img/2_big.2c4ebf44.png";